import React from "react";
import LoadingSpinner from "./Loading/Loading";

const DataTable = ({ categoriesData, isLoading, categoryTitle, isAuthor=false }) => (
    <div className="overflow-x-auto">
        <table className="table-auto w-full">
            <thead className="text-xs font-semibold uppercase text-gray-400 bg-slate-100">
                <tr>
                    {
                        categoryTitle?.map((item, index) => {
                            return (
                                <th
                                    key={item?.id}
                                    scope="col"
                                    className="py-3.5 pl-8 pr-3 text-center text-sm font-semibold text-gray-900"
                                >
                                    {item?.title}
                                </th>
                            )
                        })
                    }
                </tr>
            </thead>
            <tbody className="text-sm divide-y divide-gray-100">
                {isLoading ? (
                    <>
                        <tr>
                            <td colSpan="5" className="py-4">
                                <LoadingSpinner />
                            </td>
                        </tr>
                    </>
                ) : (
                    <>
                        {
                            categoriesData?.length > 0 &&
                            categoriesData?.map((project) => (
                                <tr
                                    key={project?._id}
                                    className="border-b border-gray-200 even:bg-slate-50"
                                >
                                    <td className="py-4 pl-8 pr-3 text-sm text-gray-500">
                                        {project?._id}
                                    </td>
                                    {/* <td className="px-3 py-4 text-sm text-gray-500">{project.title}</td> */}
                                    {
                                        project?.category && isAuthor? (
                                            <td className="px-3 py-4 text-sm text-gray-500 whitespace-nowrap w-32 text-center">
                                                {project?.category}
                                            </td>
                                        ) : null
                                    }
                                    <td className="px-3 py-4 text-sm text-gray-500 hover:text-blue-500">
                                        <a
                                            target="_blank"
                                            rel="noreferrer"
                                            href={project?.pageUrl}
                                        >
                                            {project?.pageUrl}
                                        </a>
                                    </td>
                                    
                                    <td className="px-3 py-4 text-sm text-gray-500 whitespace-nowrap w-32 text-center">
                                        {project?.pageView}
                                    </td>
                                    <td className="px-3 py-4  text-sm text-gray-500 sm:table-cell w-32 text-center">
                                        {project?.uniqueUsers}
                                    </td>
                                    <td className="px-3 py-4  text-sm text-gray-500 sm:table-cell w-32 text-center">
                                        {project?.newUsers}
                                    </td>
                                    <td className="px-3 py-4  text-sm text-gray-500 sm:table-cell w-32 text-center">
                                        {project?.returningUsers}
                                    </td>
                                    {/* <td className="px-3 py-4 text-left text-sm text-gray-500 sm:table-cell w-32">{project.pvuser}</td> */}
                                    {/* <td className="py-4 pl-3 pr-4 text-left text-sm text-gray-500">{project.age}</td> */}
                                </tr>
                            ))}
                    </>
                )}
            </tbody>
        </table>
    </div>
);

export default DataTable;
